import request from '@host-panel/request';

export function loadSSOAccount(
spotId: string,
type: string
) {
  return request(`/host-panel/sso-account/${spotId}/${type}`, {
    method: 'GET',
    data: {}
  });
}


